/* PRELUDIO v7/v8 - carrello, pagina 404, cuore wishlist in testata, testi del piede */
(function () {
  function carrello() {
    document.querySelectorAll('.line-item p.smallcaps.text-subdued, .line-item .smallcaps.text-subdued').forEach(function (p) {
      var t = p.textContent.trim();
      if (/^[0-9]{1,3}([.,][0-9])?$|^(XXS|XS|S|M|L|XL|XXL|UNI|TU)$/i.test(t)) p.textContent = 'Taglia ' + t;
    });
    /* nota all'ordine: resta una nota normale; la richiesta di fattura e' solo un suggerimento nel testo */
    document.querySelectorAll('cart-note textarea').forEach(function (ta) {
      if (ta.dataset.pl) return; ta.dataset.pl = '1';
      ta.placeholder = "Nota per l'ordine. Per la fattura indicare Partita IVA o Codice SDI.";
    });
  }
  function pagina404() {
    if (!/404/.test(document.title)) return;
    var b = document.querySelector('main .button, main a.button'); if (!b || document.querySelector('.pl-404-link')) return;
    var nav = document.createElement('div'); nav.className = 'pl-404-link';
    nav.style.cssText = 'display:flex;flex-wrap:wrap;justify-content:center;align-items:center;gap:10px;margin:24px 0 0';
    [['Donna', '/collections/donna-autunno-inverno-2026'], ['Uomo', '/collections/uomo-autunno-inverno-2026'], ['Kids', '/collections/kids-autunno-inverno-2026'], ['Cerca', '/search']].forEach(function (v) {
      var a = document.createElement('a'); a.href = v[1]; a.textContent = v[0];
      a.style.cssText = 'display:inline-block !important;margin:0 !important;min-height:0 !important;height:auto !important;font-size:11px !important;letter-spacing:.14em;text-transform:uppercase;color:#000 !important;text-decoration:none !important;padding:9px 18px !important;border:1px solid rgba(0,0,0,.2) !important;border-radius:999px;background:none !important;line-height:1.2 !important;box-shadow:none !important';
      nav.appendChild(a);
    });
    b.parentNode.insertBefore(nav, b.nextSibling);
  }
  function cuore() {
    if (document.querySelector('.custom-header-wishlist')) return;
    var cart = document.querySelector('.header__secondary-nav .header__cart-link'); if (!cart) return;
    var li = document.createElement('li'); li.className = 'header__wishlist-link';
    li.innerHTML = '<a class="custom-header-wishlist" href="/pages/wishlist" aria-label="Wishlist"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.4-9.3C1.3 7.9 3.4 4.5 6.8 4.5c2.1 0 3.6 1.2 5.2 3.1 1.6-1.9 3.1-3.1 5.2-3.1 3.4 0 5.5 3.4 4.2 6.7-1.9 4.7-9.4 9.3-9.4 9.3z"/></svg></a>';
    cart.parentNode.insertBefore(li, cart);
    li.querySelector('a').addEventListener('click', function (e) {
      if (window._swat) {
        e.preventDefault();
        if (window._swat.ui && typeof window._swat.ui.open === 'function') window._swat.ui.open();
        else if (typeof window._swat.showWishlist === 'function') window._swat.showWishlist();
        else location.href = '/pages/wishlist';
      }
    });
  }
  function testi() {
    var mappa = { 'iscriviti alla newsletter': 'Iscriviti', 'italiano': 'IT', 'english': 'EN' };
    var f = document.querySelector('footer'); if (!f) return;
    var w = document.createTreeWalker(f, NodeFilter.SHOW_TEXT), n, lista = [];
    while ((n = w.nextNode())) lista.push(n);
    lista.forEach(function (t) { var k = t.nodeValue.trim().toLowerCase(); if (mappa[k]) t.nodeValue = t.nodeValue.replace(t.nodeValue.trim(), mappa[k]); });
  }
  function avvia() { cuore(); carrello(); pagina404(); testi(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia); else avvia();
  window.addEventListener('load', testi);
  document.addEventListener('cart:change', function () { setTimeout(carrello, 300); });
  document.addEventListener('cart:refresh', function () { setTimeout(carrello, 300); });
  var g = function () { var a = document.querySelector('a.preludio-guida'); if (a) { a.style.setProperty('display', 'inline-block', 'important'); a.style.setProperty('width', 'fit-content', 'important'); a.style.setProperty('align-self', 'flex-start', 'important'); } };
  setTimeout(g, 600); setTimeout(g, 1500);
})();